import * as t from 'io-ts';
import { authorizedTo, entityItems, forms, id, meta, users } from '@/services/api';
import { filterCodec as groupCodec } from '@/services/api/resources/group';
import { ruleCodec, sendableRuleCodec } from '@/services/api/resources/rrule/codec';

const reminderCodec = t.type({
  id: t.union([t.number, t.null]),
  direction: t.string,
  scale: t.string,
  timeShift: t.number,
  type: t.string,
  value: t.number,
});

const data = t.type({
  title: t.union([t.string, t.null]),
  checklists: forms,
  assignees: users,
  assignedGroups: t.array(groupCodec),
  supervisors: users,
  supervisorGroups: t.array(groupCodec),
  rule: ruleCodec,
  entities: entityItems,
  allEntityItems: t.boolean,
  separateTodoForAllUsers: t.boolean,
  dueIn: t.union([t.number, t.null]),
  entityItemSpecificAssignments: t.boolean,
  reminders: t.array(reminderCodec),
});

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});

export const detailCodec = t.type({
  data,
  authorizedTo,
});

export const formCodec = t.type({
  title: t.string,
  assignees: t.array(t.union([t.number, t.string])),
  assignedGroups: t.array(t.union([t.number, t.string])),
  supervisors: t.array(t.union([t.number, t.string])),
  supervisorGroups: t.array(t.union([t.number, t.string])),
  checklists: t.array(t.union([t.number, t.null])),
  rule: ruleCodec,
  entities: t.array(t.union([t.number, t.null])),
  allEntityItems: t.boolean,
  separateTodoForAllUsers: t.boolean,
  dueIn: t.union([t.number, t.null]),
  entityItemSpecificAssignments: t.boolean,
  reminders: t.array(reminderCodec),
});

const sendableUserGroupCodec = t.type({
  users: t.array(t.union([t.number, t.string])),
  groups: t.array(t.union([t.number, t.string])),
});

const sendableEntitiesCoded = t.type({
  entityItems: t.array(t.union([t.number, t.null])),
  allEntityItems: t.boolean,
});

const sendableTargetCodec = t.intersection([sendableUserGroupCodec, sendableEntitiesCoded]);

export const sendableCodec = t.type({
  title: t.string,
  assignees: sendableTargetCodec,
  supervisors: sendableUserGroupCodec,
  rule: sendableRuleCodec,
  checklists: t.array(t.union([t.number, t.null])),
  separateTodoForAllUsers: t.boolean,
  dueIn: t.union([t.number, t.null]),
  entityItemSpecificAssignments: t.boolean,
  reminders: t.array(reminderCodec),
});
